(function ($) {
  require('../../scss/main.scss');
  require('./lightbox-function');
  require('./select-touch');
  require('./nav-tabs')(992);

  window.GoogleMapClass = require('../map-class')

  $(document).ready(() => {
    // var pageInfo = require('./pageInfo')();

    if (!String.prototype.startsWith) {
        String.prototype.startsWith = function(searchString, position){
          position = position || 0;
          return this.substr(position, searchString.length) === searchString;
      };
    }

    var body = $('body'),
        mainNav = $('#main-nav')

    body.removeClass('no-js').addClass('js');
    // addResponziveClass();
    // addBrowserClass();

    // $(window).resize(function() {
    //   pageInfo.update();
    //   addResponziveClass();
    // })

    $('#open-mmenu').on('click', e => {
      mainNav.toggleClass('active');
      body.toggleClass('mmenu-opened');
    })

    // function addResponziveClass() {
    //   var theClass = detectmob() === null ? '' : detectmob();
    //   body.removeClass('lg md sm xs xxs').addClass(pageInfo.device + ' ' + theClass);
    // }

    // kontrola, zda je ukladani do localStorage vubec mozne
    // (napr. Safari, iOS anonymni rezeim - v tom to nefunguje a formular se pote neda odeslast)
    function isLocalStorageNameSupported() {
        var testKey = 'test', storage = window.localStorage;
        try {
            storage.setItem(testKey, '1');
            storage.removeItem(testKey);
            return true;
        } catch (error) {
            return false;
        }
    }

    if(!isLocalStorageNameSupported())
      $('.footer-toggle-device').remove()

    if (typeof (Storage) !== 'undefined' && isLocalStorageNameSupported()) {
      var viewport = document.querySelector('meta[name=viewport]');
      var strg = localStorage.getItem('switchMobileDesktop');

      if (detectmob()) {
        $('.footer-toggle-device').addClass('show');
        if (strg === 'desktop')
          viewport.setAttribute('content', 'width=1160, initial-scale=1.0');
        else
          viewport.setAttribute('content', 'width=device-width, initial-scale=1.0');
      }
    }

    /* Funkce pro prepnuti mobilni verze na desktopovou. Je navazana na tlacitko */
    $('.footer-toggle-device a').click(function(e){
      e.preventDefault();
      var type = $(this).data('type');
      var viewport = document.querySelector('meta[name=viewport]');

      if (type === 'desktop') {
        viewport.setAttribute('content', 'width=1160, initial-scale=1.0');
        localStorage.setItem('switchMobileDesktop', 'desktop');
      } else {
        viewport.setAttribute('content', 'width=device-width, initial-scale=1.0');
        localStorage.setItem('switchMobileDesktop', 'mobile');
      }
    });

    // registrace na win pro volani v componente lightbox
    window.replacePlaceholder = () => true;

    /* Funkce pro detekovani mobilniho zarizeni */
    function detectmob() {
      return ( navigator.userAgent.match(/Android/i)
        || navigator.userAgent.match(/webOS/i)
        || navigator.userAgent.match(/iPhone/i)
        || navigator.userAgent.match(/iPad/i)
        || navigator.userAgent.match(/iPod/i)
        || navigator.userAgent.match(/BlackBerry/i)
        || navigator.userAgent.match(/Windows Phone/i));
    }

    // // prida tridu body dle prohlizece
    // function addBrowserClass() {
    //   let theClass = 'browser-',
    //     browser = pageInfo.browser.toLowerCase();
    //
    //   if (browser.indexOf('chrome') >= 0)
    //     theClass += 'chrome';
    //   else if(browser.indexOf('firefox') >= 0)
    //     theClass += 'firefox';
    //   else if(browser.indexOf('safari') >= 0)
    //     theClass += 'safari';
    //   else if(browser.indexOf('opera') >= 0)
    //     theClass += 'opera';
    //   else if(browser.indexOf('IE') >= 0)
    //     theClass += 'ie';
    //   else // trident
    //     theClass += 'ie';
    //
    //   // detekce nativniho android browseru
    //   function isNativeAndriodBrowser() {
    //     var nua = navigator.userAgent.toLowerCase();
    //     var is_android = ((nua.indexOf('mozilla/5.0') > -1 && nua.indexOf('android ') > -1 && nua.indexOf('applewebkit') > -1) && !(nua.indexOf('chrome') > -1));
    //
    //     if (is_android)
    //       theClass += ' native-android-browser';
    //   };
    //
    //   isNativeAndriodBrowser();
    //
    //   body.addClass(theClass);
    // }

    //Vytvorenie after submit funkcie, ktorá bude zavolaná po odoslaní formulára na server
    window.generalFormAfterSubmitFunction = function() {
      $().lightbox.create('<div class="sa-preloader"><div class="preloader"></div></div>', 'lb-loader').hideX();
    };
    //Vytvorenie after response funkcie, zavolaná po prijatí odpovede
    window.generalFormAfterResponseFunction = function() {
      $().lightbox.destroy();
    };
  })
})(jQuery);
